export default {
	"vehicleType": {
		"vehicletypeCode": "รหัสรุ่น",
		"vehicleLoad": "โหลดรุ่น",
		"vehicleType": "ประเภทรุ่น",
		"cubage": "ปริมาตรของรุ่น",
		"updateUser": "ผู้ปรับปรุง",
		"uploadDt": "ปรับเปลี่ยนเวลา",
		"vehicleInformation": "ข้อมูลรุ่น",
		"vehicleLength": "ความยาวของยานพาหนะ",
		"vehicleWidth": "ความกว้างของยานพาหนะ",
		"vehicleHeight": "ความสูงของยานพาหนะ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/vehicleType/vehicleType.js